module.exports = __webpack_public_path__ + "img/仓储-发货标签.b9d113b5.jpg";